import { Injectable } from '@angular/core';
import { AuthState, LogoutUser } from '../modules/shared/state/auth';
import { Store } from '@ngxs/store';
import { CanActivate } from '@angular/router';

@Injectable()
export class FinancialGuard implements CanActivate {
  constructor(private store: Store) {}

  public canActivate(): any {
    const isAuthenticated = this.store.selectSnapshot(AuthState.isAuthenticated);
    const isFinancial = this.store.selectSnapshot(AuthState.isFinancial);

    if (!isAuthenticated || !isFinancial) {
      return this.store.dispatch(new LogoutUser());
    }

    return isAuthenticated;
  }
}
